const { useScrollbar } = window.BAO.Carousel.plugins

class ImageAndAccordionsCarousel extends window.BAO.Carousel.CarouselElement {
  /** @returns {KeenSliderOptions} */
  get options () {
    let slidesPerView = 1.35
    if (this.els.slide.elements.length === 1) {
      slidesPerView = 1
    }

    return {
      selector: this.els.slide.selector,
      loop: false,
      mode: 'snap',
      slides: {
        perView: slidesPerView,
        spacing: 10,
      },
    }
  }

  /** @returns {KeenSliderPlugins[]} */
  get plugins () {
    return [useScrollbar(this.els?.progressbar?.element)]
  }
}

if (!customElements.get('image-and-accordions-carousel')) {
  customElements.define(
    'image-and-accordions-carousel',
    ImageAndAccordionsCarousel,
  )
}
